import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/chipnest-logo.jpg";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="gy-4">
          <Col lg={4} md={6}>
            <div className="footer-about">
              <div className="footer-logo">
                <img src={logo} alt="Chip Mentors" />
                <h5>Chipnest Semiconductor</h5>
              </div>

              <p>
                Chipnest Semiconductor prepares future semiconductor
                professionals through hands-on learning and real design
                challenges. Our programs mirror modern chip development needs,
                helping learners gain deep technical skills and practical
                confidence to succeed in fast-paced VLSI careers.
              </p>

              <h6>Follow Us On:</h6>
              <div className="social-icons">
                <div className="social-icons">
                  <a href="#">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/chipnest-semiconductor-pvt-ltd/" target="_blank">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </Col>

          {/* USEFUL LINKS */}
          <Col lg={2} md={6}>
            <h5 className="footer-title">Useful Links</h5>
            <ul className="footer-links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/courses">Courses</NavLink>
              </li>
              <li>
                <NavLink to="/careers">Careers</NavLink>
              </li>
              <li>
                <NavLink to="/contact">Contact</NavLink>
              </li>
            </ul>
          </Col>

          {/* RESOURCES */}
          <Col lg={3} md={6}>
            <h5 className="footer-title">Resources</h5>
            <ul className="footer-links">
              {/* <li><NavLink to="/interview-prep">Interview Prep</NavLink></li>
              <li><NavLink to="/blog">Blog & Articles</NavLink></li> */}
              <li>
                <NavLink to="/terms">Terms & Conditions</NavLink>
              </li>
            </ul>
          </Col>

          {/* CONTACT */}
          {/* CONTACT */}
          <Col lg={3} md={6}>
            <h5 className="footer-title">Contact Us</h5>

            <ul className="footer-contact">
              <li>
                <i
                  className="fas fa-map-marker-alt"
                  style={{
                    marginRight: "10px",
                    color: "#0d6efd",
                    fontSize: "18px",
                  }}
                ></i>

                <span>
                  3rd floor, above nest bakery, opp to irani chai, ckb layout,
                  munnekollala, marathahalli, bangalore, 560037
                </span>
              </li>

              <li>
                <i
                  className="fas fa-phone-alt"
                  style={{
                    marginRight: "10px",
                    color: "#0d6efd",
                    fontSize: "18px",
                  }}
                ></i>

                <span>+91 9483484071</span>
              </li>

              <li>
                <i
                  className="fas fa-envelope"
                  style={{
                    marginRight: "10px",
                    color: "#0d6efd",
                    fontSize: "18px",
                  }}
                ></i>

                <span>chipnestsemiconductor@gmail.com</span>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* COPYRIGHT */}
      <div className="footer-bottom">© 2026 Chipnest. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
